module.exports = __webpack_public_path__ + "static/media/mn.75c34372.svg";